import script from "./SuperadminUsersView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminUsersView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminUsersView.vue?vue&type=style&index=0&id=aafc012e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aafc012e"]])

export default __exports__